import { Pagination } from "@ir/ui";
import { PageFooter } from "@src/presentation/components/Layout/common";
import ErrorBoundary from "@src/presentation/components/common/ErrorBoundary";

interface MasterDataListFooterProps {
  total: number;
  page: number;
  limit: number;
  loading: boolean;
  onPageChange: (page: number) => void;
  ariaLabel?: string;
}

/** Shared pagination footer for Master Data list providers. */
export const MasterDataListFooter = ({
  total,
  page,
  limit,
  loading,
  onPageChange,
  ariaLabel = "Master Data Pagination",
}: MasterDataListFooterProps) => {
  if (total <= limit) {
    return null;
  }

  return (
    <ErrorBoundary>
      <PageFooter className="bg-white" style={{ bottom: -24 }}>
        <Pagination
          totalItems={total}
          itemsPerPage={limit}
          currentPage={page}
          onPageChange={onPageChange}
          isDisabled={loading}
          aria-label={ariaLabel}
        />
      </PageFooter>
    </ErrorBoundary>
  );
};
